import React, { useState, useEffect } from "react";

import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Flex,
  IconButton,
  Text,
  Icon,
  Badge,
  Collapse,
  useDisclosure,
  VStack, // ✅ Add this
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import axios from "axios";

import {
  FaUserShield,
  FaTasks,
  FaUsers,
  FaPlus,
  FaFileAlt,
  FaEnvelope,
  FaChevronDown,
  FaChevronRight,
  FaChartBar,
  FaNewspaper,
  FaVideo,
  FaBlogger,
  FaPenFancy,
  FaLayerGroup,
  FaClipboardList,
  FaFolderOpen,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import { FiMessageCircle } from "react-icons/fi";
import * as mod from "./../url";
import { LuLayoutDashboard } from "react-icons/lu";
import { NavLink } from "react-router-dom";
const SIDEBAR_WIDTH = "250px";
const Sidebar = () => {
  const [selectedSection, setSelectedSection] = useState("dashboard");

  const { isOpen, onOpen, onClose } = useDisclosure();
  const authDisclosure = useDisclosure();
  const [adminData, setAdminData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;

  const adminId = storedData?.data.superAdmin._id;
  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        const { data } = await axios.get(
          `${mod.api_url}/api/v1/superAdmin/Super_admin_byid/${adminId}`,
          {
            headers: {
              Authorization: ` ${token}`,
            },
          },
        );
        setAdminData(data.admin);
      } catch (err) {
        console.error("API Error:", err.response || err.message);
        setError("Failed to fetch admin data");
      } finally {
        setLoading(false);
      }
    };

    if (adminId) {
      fetchAdmin();
    } else {
      setLoading(false);
      setError("Admin ID not found in session.");
    }
  }, [adminId]);

  return (
    <>
      <IconButton
        aria-label="Open menu"
        icon={<HamburgerIcon />}
        display={{ base: "block", md: "none" }}
        onClick={onOpen}
        position="fixed"
        top="25px"
        left="10px"
        zIndex="1500"
        bg="white"
        border="1px solid lightgray"
        _hover={{ bg: "gray.100" }}
      />

      {/* Sidebar - Desktop */}
      <Box
        width={SIDEBAR_WIDTH}
        bg="#1f2a40"
        color="white"
        display={{ base: "none", md: "block" }}
        position="fixed"
        top="0"
        left="0"
        height="100vh"
        overflowY="auto"
        p={4}
        pt="70px"
        zIndex="999"
      >
        <Text
          fontSize="2xl"
          fontWeight="bold"
          mb={6}
          mt="20px"
          backgroundColor={"#6366F1"}
          p={2}
          borderRadius="md"
          textAlign={"center"}
          display={"block"}
        >
          {adminData?.fullName || "Supper Admin"}
        </Text>

        {/* Sidebar items */}
        <SidebarItem
          icon={LuLayoutDashboard}
          label="Dashboard"
          to="/"
          color="#6366F1"
        />
        <SidebarItem
          icon={LuLayoutDashboard}
          label="All-Voters"
          to="/all-voters"
          color="#6366F1"
        />

        <SidebarItem
          icon={FaPenFancy}
          label="Drafts"
          to="/all-legal-draft"
          color="#F59E0B"
        />
        {/* <SidebarItem
          icon={FaFileAlt}
          label="Articles"
          to="/get-all-articles"
          color="#EF4444"
        /> */}
        {/* <SidebarItem
          icon={FaBlogger}
          label="Blogs"
          to="/get-all-story"
          color="#10B981"
        /> */}
        {/* <SidebarItem
          icon={FaNewspaper}
          label="News"
          to="/manage-news"
          color="#EF6C00"
        /> */}
        {/* <SidebarItem
          icon={FaVideo}
          label="Videos"
          to="/manage-videos"
          color="#7C3AED"
        /> */}
        {/* <SidebarItem
          icon={FaFolderOpen}
          label=" Question Category"
          to="/create-category"
          color="#06B6D4"
        /> */}
        <SidebarItem
          icon={FaFolderOpen}
          label=" Awards Category"
          to="/create-award-category"
          color="#06B6D4"
        />
        <SidebarItem
          icon={FaNewspaper}
          label="Candidates"
          to="/all-candidates"
          color="#EF6C00"
        />
        <SidebarItem
          icon={FaFolderOpen}
          label="Results"
          to="/candidate-results"
          color="#06B6D4"
        />
        <SidebarItem
          icon={FaUsers}
          label="Users"
          to="/jobseeker-users"
          color="#f7f331ff"
        />
        {/* <SidebarItem
          icon={FaUsers}
          label="Meet Users"
          to="/meet-users-get"
          color="#d406b8ff"
        /> */}
        <SidebarItem
          icon={FaEnvelope}
          label="Emial Subscriber"
          to="/email-subscriber"
          color="#7af515ff"
        />
        <SidebarItem
          icon={FiMessageCircle}
          label="contact Data"
          to="/contact-us"
          color="#09eecfff"
        />
        <SidebarItem
          icon={FaFileAlt}
          label="Home-Banner"
          to="/home-banner"
          color="#ee1342ff"
        />
        <SidebarItem
          icon={FaFileAlt}
          label="Buyer-Draft"
          to="/paid-draft"
          color="#eed813ff"
        />
        {/* <SidebarItem
          icon={FaFileAlt}
          label="Moot Application"
          to="/moot-application"
          color="#eed813ff"
        /> */}
      </Box>

      {/* Drawer - Mobile */}
      <Drawer placement="left" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Menu</DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" spacing={4}>
              <Link to="/admin-profile" onClick={onClose}>
                <Button width="100%" colorScheme="blue">
                  Dashboard
                </Button>
              </Link>
              <Link to="/manage-job" onClick={onClose}>
                <Button width="100%" colorScheme="blue">
                  Manage Job
                </Button>
              </Link>
              <Link to="/moot-application" onClick={onClose}>
                <Button width="100%" colorScheme="blue">
                  Moot Applications
                </Button>
              </Link>
              <Link to="/all-legal-draft" onClick={onClose}>
                <Button width="100%" colorScheme="blue">
                  All Draft
                </Button>
              </Link>

              <Link to="/contact" onClick={onClose}>
                {/* <Button width="100%" colorScheme="blue">Contact Data</Button> */}
              </Link>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

const SidebarItem = ({
  icon,
  label,
  to,
  badge,
  badgeColor = "red",
  collapsible = false,
  disclosure,
  hidden,
  color = "white",
}) => {
  if (hidden) return null;

  return (
    <NavLink
      to={to}
      style={{ textDecoration: "none" }}
      end
      className={({ isActive }) => (isActive ? "active-link" : "")}
    >
      {({ isActive }) => (
        <Flex
          align="center"
          justify="space-between"
          p={2.5}
          borderRadius="md"
          bg={isActive ? "#faa535f3" : "transparent"}
          color={isActive ? "#eeece7ff" : color}
          fontWeight={isActive ? "bold" : "normal"}
          cursor="pointer"
          _hover={{
            bg: "gray.700",
            color: "#63B3ED",
          }}
          transition="all 0.2s ease"
          onClick={collapsible ? disclosure?.onToggle : undefined}
        >
          <Flex align="center" gap={3}>
            <Icon as={icon} boxSize={5} />
            <Text fontSize="17px" m={2} textAlign={"left"}>
              {label}
            </Text>
          </Flex>

          {badge && (
            <Badge colorScheme={badgeColor} fontSize="0.6em">
              {badge}
            </Badge>
          )}

          {collapsible && (
            <Icon
              as={disclosure?.isOpen ? FaChevronDown : FaChevronRight}
              boxSize={3}
            />
          )}
        </Flex>
      )}
    </NavLink>
  );
};

export default Sidebar;
